import { render, staticRenderFns } from "./EditGeneral.vue?vue&type=template&id=aee32ddc&"
import script from "./EditGeneral.vue?vue&type=script&lang=ts&"
export * from "./EditGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./EditGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports